import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/display.css';
import './assets/index.scss'
import { Pagination, Carousel, CarouselItem, Message, Row, Col } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Row);
Vue.use(Col);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
